import { render, staticRenderFns } from "./mengban.vue?vue&type=template&id=7892d781&scoped=true"
import script from "./mengban.vue?vue&type=script&lang=js"
export * from "./mengban.vue?vue&type=script&lang=js"
import style0 from "./mengban.vue?vue&type=style&index=0&id=7892d781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7892d781",
  null
  
)

export default component.exports